var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3, _path8, _path9, _path10, _path11, _path12, _polygon, _path13, _polygon2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCombinations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 751.13137,
    height: 489.52029,
    viewBox: "0 0 751.13137 489.52029",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M399.1898,633.24368l-22.05938-7.70714a75.39333,75.39333,0,0,1,1.58645-36.24062c8.3685,20.14711,34.46936,25.77988,48.96151,42.08676A45.3495,45.3495,0,0,1,438.187,669.25957l4.22387,16.02538A75.9913,75.9913,0,0,1,388.039,652.23689a73.40422,73.40422,0,0,1-8.12594-16.52483C389.4353,635.03668,399.1898,633.24368,399.1898,633.24368Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M655.33033,490.0077h-115.51a6.1631,6.1631,0,0,0-6.15377,6.16965V678.64914H661.5V496.17735A6.16641,6.16641,0,0,0,655.33033,490.0077ZM597.964,593.68594a13.70383,13.70383,0,0,1-13.63985-13.63975V558.99965a13.6398,13.6398,0,0,1,27.2796,0v21.04654A13.70363,13.70363,0,0,1,597.964,593.68594Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M533.27005,672.8126v17.6049a3.44873,3.44873,0,0,0,3.44174,3.44164H658.45485a3.459,3.459,0,0,0,3.44164-3.44164V672.8126Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M846.60453,205.23986H352.84429a16.02852,16.02852,0,0,0-16.003,16.0029V554.43427a16.01831,16.01831,0,0,0,16.003,16.0029H846.60453a16.01831,16.01831,0,0,0,16.003-16.0029V221.24276A16.02852,16.02852,0,0,0,846.60453,205.23986Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M842.48121,216.794h-485.51a8.58038,8.58038,0,0,0-8.56,8.58v324.93a8.56972,8.56972,0,0,0,8.56,8.56h485.51a8.56969,8.56969,0,0,0,8.56-8.56V225.374A8.58034,8.58034,0,0,0,842.48121,216.794Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M853.96063,224.14526v282.82a179.02234,179.02234,0,0,1-183.37-291.4h174.81A8.58036,8.58036,0,0,1,853.96063,224.14526Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M818.07711,261.567H363.7841a1.807,1.807,0,0,1,0-3.61318h454.293a1.807,1.807,0,0,1,0,3.61318Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.2741,
    cy: 32.66644,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.84912,
    cy: 32.66644,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.42414,
    cy: 32.66644,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M796.05585,229.76554h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M796.05585,237.14991h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M796.05585,244.52458h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M478.39374,459.52281a6.75989,6.75989,0,0,0-1.348-10.27748l5.54-23.3749-11.7253,4.28376-3.46326,21.54045a6.79654,6.79654,0,0,0,10.9966,7.82817Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#9e616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M506.59037,361.56982l-4.70569,12.10034s2.01673,12.10034-1.34448,14.7893-2.01672,2.689-2.01672,4.70569a10.3407,10.3407,0,0,1-4.03345,7.39466c-2.689,2.01672-14.78931,43.02343-14.78931,43.02343H467.60038a37.91153,37.91153,0,0,0,0-9.41137c-.67224-4.70569,2.01672-16.806,3.36121-18.82276s0-4.70569,0-8.73913,2.689-6.05017,2.689-12.77259,8.0669-59.15722,7.39465-65.20739,6.72242-11.4281,6.72242-11.4281H494.49Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "325.812 471.541 335.127 471.541 339.56 435.611 325.812 435.611 325.812 471.541",
    fill: "#9e616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M547.2064,670.4006l14.88188-.88825,0,6.37605L576.23691,685.66a3.98272,3.98272,0,0,1-2.26311,7.26013H556.25635l-3.05387-6.30689-1.19238,6.30689h-6.68019Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "209.063 463.627 217.718 467.072 235.125 435.33 222.352 430.245 209.063 463.627",
    fill: "#9e616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M433.03274,661.815l14.15519,4.6787-2.35814,5.92395,9.53146,14.31147a3.98271,3.98271,0,0,1-4.78775,5.90834l-16.46118-6.55268-.50477-6.98914-3.4404,5.41869-6.20652-2.47062Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M531.47,569.86773l-15.53311-72.48781L491.68149,577.9201l-38.40724,76.373-.20348.40525L440.90466,648.148c-1.717-31.01074,2.3609-60.07025,17.2757-85.48078l7.06253-69.74591c.21642-2.3832,5.48465-58.33168,22.16624-68.25337l4.8854-11.1396,48.58976-12.00054.17676.19918a37.14682,37.14682,0,0,1,8.90082,18.657L564.481,508.34061l.00819.04915-3.893,61.35983,5.32514,90.52568H546.65307Q528.773,626.63239,531.47,569.86773Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M577.41451,328.45918l29.45633-10.3052a3.65188,3.65188,0,0,1,2.41185,6.894l-29.45633,10.3052a3.65188,3.65188,0,0,1-2.41185-6.894Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M609.06454,324.11c.57637,1.99481,3.06279,2.96366,5.07,2.43187a8.23931,8.23931,0,0,0,4.61679-3.9496c1.07866-1.77426,1.81932-3.73954,2.9287-5.49475a15.41178,15.41178,0,0,1,9.30269-6.66964,16.1417,16.1417,0,0,0-9.92325,1.87951,11.97779,11.97779,0,0,1-3.47656,1.6386,30.05478,30.05478,0,0,1-3.96746-.05179,6.123,6.123,0,0,0-4.15807,10.3",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M605.21273,327.28279a6.75991,6.75991,0,0,1-8.71879,5.60593l-14.27365,19.322-4.2988-11.7198L592.135,323.9392a6.79654,6.79654,0,0,1,13.07769,3.34359Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#9e616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M477.97256,437.12791c-1.30854,0-2.05182-.25662-2.33966-.80686-.42231-.80763.31057-1.86263,1.159-3.08486.59185-.85155,2.32048-2.54485,1.47039-2.64867-12.88965-1.57412-6.70227-81.04373-1.11621-91.54831,1.135-2.13437-.06587-5.40909,1.21223-9.03109,3.49137-9.8919,8.257-12.93206,17.75086-18.98773q1.156-.7375,2.40747-1.54051c1.07928-.69357,1.01917-2.99315.95559-5.42836-.07051-2.70648-.14372-5.50544,1.18216-7.25478l.08631-.11406.1391-.03236c3.207-.74136,13.99323-2.11772,20.38105.01l.08823.03006.06589.0655c1.51739,1.51739,1.65572,4.4566,1.78942,7.29871.10943,2.33349.21308,4.53674,1.07157,5.49387,6.56314,7.31566,14.00672,7.17309,14.08224,7.17155l.36875-.01079.03662.36682c4.60139,8.75816.99861,41.28476,4.197,61.48919,3.24943,20.5267,31,38,7.238,41.10233a.51488.51488,0,0,1,.01618.53329C548.7791,422.88345,482.90464,437.12791,477.97256,437.12791Zm71.56561-17.02877Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M553.19224,377.3476l-12.83149-7.21779c-22.37546-15.50908-27.88706-27.8254-28.576-35.43-.73518-8.114,3.58771-12.55214,3.77227-12.73632l.0998-.07321,11.56688-5.91a11.64147,11.64147,0,0,1,16.23694,6.38858L554.15978,351.794l11.862-8.74905,5.05885-1.99364,4.08207-5.45842,11.21123-6.53886,8.32866,7.496L584.2285,357.49752l-5.81908,1.48194-1.23418,3.17888-.10981.07013Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M530.22585,283.20406a21.84456,21.84456,0,1,1,1.11-18.61c.1.25.19.5.28.76A21.81478,21.81478,0,0,1,530.22585,283.20406Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#9e616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M533.36581,265.35408c-.94-2.63-.53-1.26-1.48-3.88a6.53877,6.53877,0,0,1-.27,3.88h-26.01v-15.12c7.62005-3.02,15.07-5.59,19.57,0a15.12065,15.12065,0,0,1,15.12,15.12Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M524.14584,307.38405c-.02-.28-.05-.57-.09-.85a29.44785,29.44785,0,0,0-1.69-6c-.75-2.11-1.51-4.23-2.27-6.34a18.15165,18.15165,0,0,1-.85,11.52c-4.39-3.42-1.61993-11.24-7.36-11.24-13.8,0-28-11.19-28-25,0-13.80005,5.92-24.12,19.72-24.12,13.81006,0,25.01007,6.31995,25.28,20.12C511.88583,269.47408,527.3558,305.98409,524.14584,307.38405Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 261.17592,
    cy: 46.11905,
    r: 16,
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M490.97548,251.98053c-2.74,3.19-7.03,4.43-10.9,6.09a45.85493,45.85493,0,0,0-26.64,33.5c-1.07,5.97-.93,12.15-2.62,17.97-1.68,5.82-5.84,11.53-11.81,12.54-4.04.69-8.09-.87-11.89-2.41q-3.135-1.26-6.27-2.53,3.27-8.205,6.53-16.41a83.16136,83.16136,0,0,1-12.11,14.17q-11.235-4.53-22.49-9.06006c18.46.07,15.31-17.85,19.44-35.82995,2.27-9.88,21.6-16.57,25.39-25.97a28.75636,28.75636,0,0,1,52.16-2.62C493.55549,242.93054,493.66548,248.83056,490.97548,251.98053Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M974.375,694.45281l-748.75.30733a1.19068,1.19068,0,0,1,0-2.38136l748.75-.30734a1.19068,1.19068,0,0,1,0,2.38137Z",
    transform: "translate(-224.43432 -205.23986)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinations);
export default __webpack_public_path__ + "static/media/combinations.edb21eab1fe88234152951ad502f064f.svg";
export { ForwardRef as ReactComponent };